import {
	IconAtom2Outline18 as AgentIcon,
	IconFilePlusOutline18 as CreateIcon,
	IconTrash2Outline18 as DeleteIcon,
	IconPencilOutline18 as EditIcon,
} from "nucleo-ui-outline-18"

export type ProposalKind = "CREATE" | "EDIT" | "DELETE"

export function iconForKind(kind: ProposalKind) {
	if (kind === "CREATE") return CreateIcon
	if (kind === "DELETE") return DeleteIcon
	return EditIcon
}

// Agent proposals carry the AI atom so the card reads as agent-written at a
// glance; the kind tint behind it still separates create/edit/delete.
export function iconForProposal(proposal: {
	kind: ProposalKind
	authorType: string | null
}) {
	return proposal.authorType === "AGENT"
		? AgentIcon
		: iconForKind(proposal.kind)
}
